export const colPath = {
    newses: 'newses',
};
